import React,{ useEffect } from 'react';
import SignupForm from '../../components/forms/SignupForm/SignupForm';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { useParams } from 'react-router-dom';

const Signup = () => {
  
  const { uid } = useParams();

  return (
    <AuthLayout pageName="signup">
      <SignupForm userId={uid} />
    </AuthLayout>
  );
};

export default Signup;
